<script lang="ts">
import IThreadService from "@/application/IThreadService";
import Vue_, { VueConstructor } from "vue";
import IDocumentFile from "@/domain/IDocumentFile";
import fileDownload from "js-file-download";

interface InjectedKeys {
  threadService: IThreadService;
}

const Vue = Vue_ as VueConstructor<Vue_ & InjectedKeys>;

export default Vue.extend({
  name: "ThreadMboxDownloadButtonView",
  inject: {
    threadService: { from: "IThreadService" },
  },
  props: {
    mlistId: {
      type: String,
      required: true,
    },
    threadIdHash: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      downloading: false,
    };
  },
  methods: {
    async downloadMboxFile(): Promise<void> {
      this.downloading = true;
      try {
        const documentFile: IDocumentFile =
          await this.threadService.getThreadMboxEmails(
            this.mlistId,
            this.threadIdHash
          );
        fileDownload(documentFile.file, documentFile.name, "application/gzip");
      } finally {
        this.downloading = false;
      }
    },
  },
});
</script>
<template>
  <button
    @click="downloadMboxFile"
    class="btn btn-link p-0"
    title="This thread in gzipped mbox format"
    :disabled="downloading"
  >
    <i class="fa fa-fw fa-download mr-2"></i>
    <span v-if="!downloading">Download</span>
    <span v-else
      >Downloading
      <span
        class="spinner-border spinner-border-sm text-secondary"
        role="status"
      >
        <span class="sr-only">Downloading...</span>
      </span>
    </span>
  </button>
</template>
